import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CardModule } from '@epicuro-next/ataraxia/card';
import { CommercialListRibbonModule } from '@epicuro-next/ataraxia/commercial-list-ribbon';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { IntersectionModule } from '@epicuro-next/ataraxia/intersection';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { PiledMediaModule } from '@epicuro-next/ataraxia/piled-media';
import { ScrollButtonsComponent } from '@epicuro-next/ataraxia/scroll-buttons';
import { ScrollIntoViewModule } from '@epicuro-next/ataraxia/scroll-into-view';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { VideoPlayerModule } from '@epicuro-next/ataraxia/video-player';
import { WheelHorizontalScrollDirective } from '@epicuro-next/ataraxia/wheel-horizontal-scroll';
import { YoutubePlayerModule } from '@epicuro-next/ataraxia/youtube-player';
import { PRODUCT_LIST_NAMESPACE } from '@epicuro-next/constants/rule-engine/product-list-rules';
import { HotListIndicatorModule } from '@epicuro-next/features/engagement/hot-list-indicator';
import { ListsModule } from '@epicuro-next/features/lists/lists-common';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EventTrackerModule } from '@epicuro-next/platform/event-tracker';
import { MonitoringModule } from '@epicuro-next/platform/monitoring';
import { AccountsStateModule } from '@epicuro-next/state/accounts-state';
import { LookbookEntitiesModule } from '@epicuro-next/state/lookbook-entities';
import { StateNewsFeedStateModule } from '@epicuro-next/state/news-feed-state';
import { ShopTheLookStateModule } from '@epicuro-next/state/shop-the-look-state';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { UserUiStateModule } from '@epicuro-next/state/user-ui-state';

import { LookbookSpotlightItemComponent } from './components/lookbook-spotlight-item/lookbook-spotlight-item.component';
import { SpotlightItemHeaderComponent } from './components/spotlight-item-header/spotlight-item-header.component';
import { SpotlightItemComponent } from './components/spotlight-item/spotlight-item.component';
import { SpotlightComponent } from './components/spotlight/spotlight.component';

@NgModule({
  imports: [
    CommonModule,
    ImageModule,
    InfiniteScrollModule,
    StateNewsFeedStateModule,
    CardModule,
    IconsModule,
    UserUiStateModule,
    TooltipDirective,
    IntersectionModule,
    YoutubePlayerModule,
    VideoPlayerModule,
    ScrollIntoViewModule,
    MediaPreviewModule,
    ShopTheLookStateModule,
    PiledMediaModule,
    LookbookEntitiesModule,
    EventTrackerModule,
    ListsModule,
    MonitoringModule,
    AccountsStateModule,
    UserStateModule,
    HotListIndicatorModule,
    ConfigurationModule.forFeature(PRODUCT_LIST_NAMESPACE),
    ModalModule,
    CommercialListRibbonModule,
    WheelHorizontalScrollDirective,
    ScrollButtonsComponent,
  ],
  declarations: [
    SpotlightComponent,
    SpotlightItemComponent,
    LookbookSpotlightItemComponent,
    SpotlightItemHeaderComponent,
  ],
})
export class FeaturesSpotlightModule {}
